import CustomBottom from "../../components/CustomBottom";
import CustomHeader from "../../components/CustomHeader";
import React, { useMemo, useState } from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

export default function About() {
  const [type, settype] = useState("th");
  return (
    <div className="fade_In">
      <CustomHeader />
      <div
        className="flex flex-row items-center gap-4  pt-[180px]"
        style={{ justifyContent: "center" }}
      >
        <div className="w-5 h-5 bg-[#B36427]" />
        <div className="font_Kanit font-semibold" style={{ fontSize: "36px" }}>
          About Us
        </div>
        <div className="w-5 h-5 bg-[#B36427]" />
      </div>
      <div className="flex flex-row gap-[40px] justify-center items-center  mt-5">
        <div
          onClick={() => {
            settype("th");
          }}
          // href={"file/about us Th.pdf"}
          // target="_blank"
          className="flex flex-row items-center gap-5 text-[#B36427] font_Kanit font-bold hover:opacity-80 cursor-pointer active:opacity-50"
        >
          <img src="/img/icon_news.png" className="w-[40px] object-contain" />
          <p>แผ่นพับ </p>
        </div>
        <div
          onClick={() => {
            settype("en");
          }}
          // href={"file/about us Eng.pdf"}
          // target="_blank"
          className="flex flex-row items-center gap-5 text-[#B36427] font_Kanit font-bold hover:opacity-80 cursor-pointer active:opacity-50"
        >
          <img src="/img/icon_news.png" className="w-[40px] object-contain" />
          <p>brochure </p>
        </div>
      </div>
      <br />
      {type == "th" ? (
        <div className="flex flex-col justify-center items-center p-3">
            <img
              className="object-contain w-full lg:w-[90vw] mb-3"
              src="/img/แผ่นพับ ไทย-1.png"
            />
          <img
            className="object-contain w-full lg:w-[90vw]"
            src="/img/แผ่นพับ ไทย-2.png"
          />
        </div>
      ) : (
        <div className="flex flex-col justify-center items-center p-3">
          <img
            className="object-contain w-full lg:w-[90vw] mb-3"
            src="/img/แผ่นพับ Eng-1.png"
          />
          <img
            className="object-contain w-full lg:w-[90vw]"
            src="/img/แผ่นพับ Eng-2.png"
          />
        </div>
      )}

      <div
        className="p-8 font_Kanit font-semibold "
        style={{ fontSize: "36px", color: "#B36427" }}
      >
        เหตุผลและความสำคัญ
      </div>
      <div className="p-8 font_Kanit indent-10 ">
        ผ้าทอพื้นเมืองของไทยในปัจจุบันนี้มีประวัติความเป็นมาอันยาวนานและยังคงรูปแบบ
        ลวดลาย และเทคนิคในการทออันประณีตไว้ได้อย่างเป็นเอกลักษณ์
        ได้มีการค้นพบหลักฐานเกี่ยวกับผ้าที่เก่าแก่ที่สุดในประเทศไทย
        คือการค้นพบชิ้นส่วนของผ้าที่บ้านเชียง
        เห็นได้ว่าผ้าทอพื้นเมืองนั้นเป็นอีกหนึ่งในวิถีของวัฒนธรรมของชาวไทยทั้งในด้านของประโยชน์ใช้สอยในชีวิตประจำวัน
        ด้านประวัติศาสตร์และเอกลักษณ์ของชาติพันธ์
        และวัฒนธรรมไทยโดยเฉพาะอย่างยิ่งกับวิถีชีวิตของผู้หญิงไทยกับการทอผ้า
        เนื่องจากการทอผ้าเป็นส่วนหนึ่งของวัฒนธรรมดั้งเดิมของมนุษย์กลุ่มชาติพันธ์ต่าง
        ๆ ที่เกี่ยวข้องลึกซึ้งกับวิถีชีวิตและบทบาทหน้าที่ของผู้หญิงในสังคม
        ผ้าทอมีบทบาทมากในชีวิตประจำวันของชาวบ้านตั้งแต่เกิดจนตาย
        ทั้งที่เกี่ยวข้องกับการใช้สอย
        และพิธีกรรมความเชื่อทั้งที่เป็นงานมงคลและอวมงคล
        ชนชาวไทยแต่ละกลุ่มต่างมีสิ่งทอที่งดงาม
        มีเอกลักษณ์ในการคิดค้นรูปแบบและลวดลายที่แตกต่างกันออกไป
        ลักษณะพิเศษเหล่านี้เกิดจากพื้นฐานคติความเชื่อดั้งเดิม
        และสภาพแวดล้อมของแต่ละกลุ่มชนงานสิ่งทอของไทยจึงนับว่าเป็นสิ่งที่มีคุณค่า
        มีบทบาทสำคัญหลายประการและเป็นสิ่งบ่งชี้ประวัติศาสตร์ความเป็นมาของคนในชาติ
        และยังแสดงให้เห็นถึงพัฒนาการทางสติปัญญา การค้น การคิดการประดิษฐ์
        การแก้ไขปรับปรุงให้มีความเหมาะเจาะลงตัวอันเป็นส่วนสำคัญของคำว่า วัฒนธรรม
        อีกทั้งยังเป็นสิ่งที่ถ่ายทอดค่านิยมของคนรุ่นหนึ่งเอาไว้ให้รุ่นต่อมาได้ศึกษา
        งานทอผ้าของชาวไทยจึงมีเสน่ห์ควรค่าแก่การสนใจยิ่ง
        ลวดลายสีสันที่ปรากฏอยู่บนผ้าทอแต่ละผืนนับได้ว่าเป็นงานศิลปะที่มีความประณีตละเอียดอ่อน
        เป็นปรีชาญาณที่เปี่ยมไปด้วยวิญาณแห่งบรรพชน
        เป็นมรดกอันล้ำค่าที่พวกเราสมควรจะภาคภูมิใจและสืบสายความรู้เชื่อมโยงไปสู่อนาคตเพื่อให้คงอยู่ตลอดไป
      </div>

      <div
        className="p-8 font_Kanit font-semibold "
        style={{ fontSize: "36px", color: "#B36427" }}
      >
        หลักการและเหตุผล
      </div>
      <div className="p-8 font_Kanit indent-10 ">
        การจัดตั้งศูนย์ออกแบบสร้างสรรค์ผ้าและสิ่งทอ : FTCDC (Fabric and Textile
        Creative Design Center) มหาวิทยาลัยราชภัฏอุดรธานี
        เพื่อการศึกษารวบรวมวัฒนธรรมภูมิปัญญาและองค์ความรู้ผ้าทอพื้นเมืองในจังหวัดอุดรธานีและพื้นที่ภาคตะวันออกเฉียงเหนือตอนบน
        – สปป.ลาว การพัฒนากระบวนการผลิต เส้นใยและสีธรรมชาติ
        ยกระดับและสร้างมูลค่าผลิตภัณฑ์ผ้าทอพื้นเมืองของชุมชนถิ่นอย่างยั่งยืน
        การสร้างพิพิธภัณฑ์ผ้าทอพื้นเมืองอีสานและแหล่งเรียนรู้
        เพื่ออนุรักษ์และการเผยแพร่วัฒนธรรม ภูมิปัญญา
        องค์ความรู้ผ้าทอพื้นเมืองเนื่องจากจังหวัดอุดรธานีและจังหวัดใกล้เคียงยังไม่มีพิพิธภัณฑ์ผ้าทอพื้นเมืองประกอบกับเป็นหมุดหมายที่สำคัญของการเป็นเมือง
        “ธานีผ้าหมี่ขิด”และยังเป็นแหล่งเรียนรู้แหล่งท่องเที่ยวเชิงวัฒนธรรมด้านการทอผ้าพื้นเมืองตั้งแต่ต้นน้ำ
        กลางน้ำและปลายน้ำ แห่งแรกในภาคตะวันออกเฉียงเหนือ
        รวมถึงศึกษาวิจัยนวัตกรรมเส้นใยและสีย้อมจากธรรมชาติ
        การเผยแพร่องค์ความรู้วัฒนธรรมภูมิปัญญาและองค์ความรู้ผ้าทอพื้นเมืองอีกด้วย
      </div>
      <div className="flex flex-col justify-center items-center p-3">
        <img
          className="object-contain w-full lg:w-[800px]"
          src="/img/a2-2.png"
        />
      </div>
      <div
        className="p-8 font_Kanit font-semibold "
        style={{ fontSize: "36px", color: "#B36427" }}
      >
        ธานีผ้าหมี่ขิด
      </div>
      <div className="p-8 font_Kanit indent-10 ">
        จังหวัดอุดรธานีนับได้ว่าเป็นจังหวัดที่มีวิถีวัฒนธรรม
        ไม่ว่าจะเป็นแหล่งท่องเที่ยวและโบราณวัตถุที่มีชื่อเสียงเป็นมรดกโลก
        นอกจากนั้นจังหวัดอุดรธานียังเป็นอีกจังหวัดที่มีการทอผ้ามาตั้งแต่ครั้งอดีตโดยเฉพาะอย่างยิ่งการทอผ้าไหม
        จนสามารถกล่าวได้ว่าอาชีพการทอผ้าไม่เป็นเพียงแค่อาชีพเสริมของชาวบ้านเท่านั้นแต่ยังถือเป็นเอกลักษณ์ของจังหวัดอุดรธานี
        ดังจะเห็นได้จากคำขวัญประจำจังหวัดที่ได้ยกเอาเอกลักษณ์ด้านการทอผ้าที่โดดเด่นมายกย่องย่องที่ปรากฏในคำขวัญประจำจังหวัดว่า
        “หนองประจักษ์คู่เมือง ลือเลื่องแหล่งธรรมะ
        อารยธรรมบ้านเชียงมรดกโลกห้าพันปี ธานีผ้าหมี่ขิด
        ธรรมชาติเนรมิตทะเลบัวแดง” จากประโยคที่กล่าวว่า “ธานีผ้าหมี่ขิด” หมายถึง
        ผ้าไหมทอแบบขิดของจังหวัดอุดรธานีซึ่งเป็นผ้าทอที่มีชื่อเสียงและเป็นเอกลักษณ์และจังหวัดอุดรธานีได้ทอผ้าหมี่ขิดฝ้ายยาวที่สุดในโลกมีความยาว
        1,199 เมตร มีลวดลายผ้าหมี่ขิดจำนวน 660 ลาย
        ดังนั้นจังหวัดอุดรธานีจึงเป็นจังหวัดที่มีชื่อเสียงด้านการทอผ้าลายขิดฝ้ายและไหม
        จากการประกวดผ้าลายขิดที่ตำหนักภูพานราชนิเวศน์
        ผ้าลายขิดฝ้ายและไหมของจังหวัดอุดรธานีชนะเลิศติดต่อกันมาเป็นประจำทุกปี
        ตั้งแต่เริ่มมีการประกวดจนถึงปัจจุบัน
      </div>
      <div
        className="p-8 font_Kanit font-semibold "
        style={{ fontSize: "36px", color: "#B36427" }}
      >
        วัตถุประสงค์
      </div>
      <div className="p-8 font_Kanit  ">
        1.
        ศึกษารวบรวมวัฒนธรรมภูมิปัญญาและองค์ความรู้ผ้าทอพื้นเมืองในจังหวัดอุดรธานีและพื้นที่ภาคตะวันออกเฉียงเหนือตอนบน
        – สปป.ลาว
        <br />
        2. พัฒนากระบวนการผลิต เส้นใยและสีย้อมธรรมชาติ ด้วยนวัตกรรม เทคโนโลยี
        เพื่อยกระดับและสร้างมูลค่าผลิตภัณฑ์ผ้าทอพื้นเมืองของชุมชนถิ่นอย่างยั่งยืน
        <br />
        3. สร้างพิพิธภัณฑ์ผ้าทอพื้นเมืองอีสาน เพื่อเป็นแหล่งเรียนรู้
        การอนุรักษ์และการเผยแพร่วัฒนธรรม ภูมิปัญญา
        องค์ความรู้ผ้าทอพื้นเมืองให้แพร่หลาย
        <br />
        4. ศึกษาวิจัยถ่ายทอดองค์ความรู้ดั้งเดิม
        การประยุกต์นวัตกรรมในการพัฒนาผ้าและสิ่งทอส฿ชุมชน
        เพื่อยกระดับผลิตภัณฑ์และชุมชนทอผ้าพื้นเมืองสู่มาตรฐาน
        <br />
        5. เผยแพร่องค์ความรู้วัฒนธรรมภูมิปัญญาและองค์ความรู้ผ้าทอพื้นเมือง
      </div>
      <div className="flex flex-col justify-center items-center p-3">
        <img className="object-contain w-full lg:w-[500px]" src="/img/a3.png" />
        <img className="object-contain w-full lg:w-[500px]" src="/img/a4.png" />
        <div
          className="p-8 font_Kanit font-semibold "
          style={{ fontSize: "36px", color: "#B36427" }}
        >
          ศูนย์ออกแบบสร้างสรรค์ผ้าและสิ่งทอ : FTCDC (Fabric and Textile Creative
          Design Center)
        </div>
        <img className="object-contain w-full lg:w-[700px]" src="/img/a5.jpg" />
        <div className="p-8 font_Kanit  ">
          <p>ชั้นที่ 1</p>
          <p className="pl-5">
            • Learning Space การสาธิตและฝึกทักษะการผลิตผ้าทอครบวงจร <br />•
            Design Shop ร้านจำหน่ายผลิตภัณฑ์ผ้าและสิ่งทอชุมชน
          </p>
        </div>
      </div>

      <div className="flex flex-col justify-center items-center p-3">
        <img className="object-contain w-full lg:w-[700px]" src="/img/a6.jpg" />
        <div className="p-8 font_Kanit  ">
          <p>ชั้นที่ 2</p>
          <p className="pl-5">
            • Museum of Esan พิพิธภัณฑ์ผ้าอีสาน
            แสดงม้วนผ้าหมี่ขิดที่ยาวที่สุดในโลก
            <br />• Khowlegdge สารสนเทศผ้าและสิ่งทอชุมชน
            ภูมิวัฒนธรรมการทอผ้าอดีต-ปัจจุบัน
          </p>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center p-3">
        <img className="object-contain w-full lg:w-[700px]" src="/img/a7.jpg" />
        <div className="p-8 font_Kanit  ">
          <p>ชั้นที่ 3</p>
          <p className="pl-5">
            • Design space ให้คำปรึกษาเชิงลึกในการออกแบบพัฒนาผลิตภัณฑ์ผ้าทอชุมชน
            <br />• Seminar การประชุม สัมมนา
            เสวนาการออกแบบพัฒนาผลิตภัณฑ์แฟชั่นสิ่งทอ
          </p>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center p-3">
        <img
          className="object-contain w-full lg:w-[800px]"
          src="/img/แผนผังตึกftcdc1.jpg"
        />
      </div>
      {/* <div className="p-8 flex-col md:flex-row w-full gap-[40px] items-center">
        <div
          className="font_Kanit font-semibold "
          style={{ fontSize: "36px", color: "#B36427" }}
        >
          Background - เหตุผลและความสำคัญ
        </div>
        <br />
        <div className="font_Kanit ">
          ผ้าทอพื้นเมืองของไทยในปัจจุบันนี้มีประวัติความเป็นมาอันยาวนานและยังคงรูปแบบ
          ลวดลาย และเทคนิคในการทออันประณีตไว้ได้อย่างเป็นเอกลักษณ์
          ผ้าทอมือและการทอผ้าด้วยมือเป็นรากฐานที่สำคัญในการดำรงชีวิตในขั้นพื้นฐานของชาวชนบท
          นับว่าเป็นอาชีพสำคัญอาชีพหนึ่งของประเทศรองลงมาจากอาชีพเกษตรกรรมซึ่งเป็นอาชีพหลัก
          ผ้าทอพื้นเมืองของไทยมีวิวัฒนาการมาช้านานและยังคงรักษารูปแบบ ลวดลาย
          ตลอดจนกรรมวิธีการทออันประณีตแบบโบราณไว้ได้
          ได้มีการค้นพบหลักฐานเกี่ยวกับผ้าที่เก่าแก่ที่สุดในประเทศไทย
          คือการค้นพบชิ้นส่วนของผ้าที่บ้านเชียง
          จะเห็นได้ว่าผ้าทอพื้นเมืองนั้นเป็นอีกหนึ่งในวิถีของวัฒนธรรมของชาวไทยทั้งในด้านของประโยชน์ใช้สอยในชีวิตประจำวัน
          ด้านประวัติศาสตร์และเอกลักษณ์ของชาติพันธ์
          และวัฒนธรรมไทยโดยเฉพาะอย่างยิ่งกับวิถีชีวิตของผู้หญิงไทยกับการทอผ้า
          เนื่องจากการทอผ้าเป็นส่วนหนึ่งของวัฒนธรรมดั้งเดิมของมนุษย์กลุ่มชาติพันธ์ต่าง
          ๆ ที่เกี่ยวข้องลึกซึ้งกับวิถีชีวิตและบทบาทหน้าที่ของผู้หญิงในสังคม
          ผ้าเป็นความจำเป็นพื้นฐานของมนุษย์
          มีความสำคัญในวิถีชีวิตของชาวบ้านทุกท้องถิ่น
          มนุษย์รู้จักการทอผ้ามาเป็นระยะเวลาพันปี
          ผ้าทอมีบทบาทมากในชีวิตประจำวันของชาวบ้านตั้งแต่เกิดจนตาย
          ทั้งที่เกี่ยวข้องกับการใช้สอย
          และพิธีกรรมความเชื่อทั้งที่เป็นงานมงคลและอวมงคล
          ชนชาวไทยแต่ละกลุ่มต่างมีสิ่งทอที่งดงาม
          มีเอกลักษณ์ในการคิดค้นรูปแบบและลวดลายที่แตกต่างกันออกไป
          ลักษณะพิเศษเหล่านี้เกิดจากพื้นฐานคติความเชื่อดั้งเดิม
          และสภาพแวดล้อมของแต่ละกลุ่มชนงานสิ่งทอของไทยจึงนับว่าเป็นสิ่งที่มีคุณค่า
          มีบทบาทสำคัญหลายประการและเป็นสิ่งบ่งชี้ประวัติศาสตร์ความเป็นมาของคนในชาติ
          และยังแสดงให้เห็นถึงพัฒนาการทางสติปัญญา การค้น การคิดการประดิษฐ์
          การแก้ไขปรับปรุงให้มีความเหมาะเจาะลงตัวอันเป็นส่วนสำคัญของคำว่า
          วัฒนธรรม
          อีกทั้งยังเป็นสิ่งที่ถ่ายทอดค่านิยมของคนรุ่นหนึ่งเอาไว้ให้รุ่นต่อมาได้ศึกษา
          งานทอผ้าของชาวไทยจึงมีเสน่ห์ควรค่าแก่การสนใจยิ่ง
          ลวดลายสีสันที่ปรากฏอยู่บนผ้าทอแต่ละผืนนับได้ว่าเป็นงานศิลปะที่มีความประณีตละเอียดอ่อน
          เป็นปรีชาญาณที่เปี่ยมไปด้วยวิญาณแห่งบรรพชน
          เป็นมรดกอันล้ำค่าที่พวกเราสมควรจะภาคภูมิใจและสืบสายความรู้เชื่อมโยงไปสู่อนาคตเพื่อให้คงอยู่ตลอดไป
        </div>
        <br />
        <div className="font_Kanit ">
          จังหวัดอุดรธานีนับได้ว่าเป็นจังหวัดที่มีวิถีวัฒนธรรม
          ไม่ว่าจะเป็นแหล่งท่องเที่ยวและโบราณวัตถุที่มีชื่อเสียงเป็นมรดกโลก
          นอกจากนั้นจังหวัดอุดรธานียังเป็นอีกจังหวัดที่มีการทอผ้ามาตั้งแต่ครั้งอดีตโดยเฉพาะอย่างยิ่งการทอผ้าไหม
          จนสามารถกล่าวได้ว่าอาชีพการทอผ้าไม่เป็นเพียงแค่อาชีพเสริมของชาวบ้านเท่านั้นแต่ยังถือเป็นเอกลักษณ์ของจังหวัดอุดรธานี
          ดังจะเห็นได้จากคำขวัญประจำจังหวัดที่ได้ยกเอาเอกลักษณ์ด้านการทอผ้าที่โดดเด่นมายกย่องย่องที่ปรากฏในคำขวัญประจำจังหวัดว่า
          “หนองประจักษ์คู่เมือง  ลือเลื่องแหล่งธรรมะ
          อารยธรรมบ้านเชียงมรดกโลกห้าพันปี ธานีผ้าหมี่ขิด
          ธรรมชาติเนรมิตทะเลบัวแดง” จากประโยคที่กล่าวว่า “ธานีผ้าหมี่ขิด”
          หมายถึง
          ผ้าไหมทอแบบขิดของจังหวัดอุดรธานีซึ่งเป็นผ้าทอที่มีชื่อเสียงและเป็นเอกลักษณ์และจังหวัดอุดรธานีได้ทอผ้าหมี่ขิดฝ้ายยาวที่สุดในโลกมีความยาว1,199
          เมตร มีลวดลายผ้าหมี่ขิดจำนวน 660 ลาย
          ดังนั้นจังหวัดอุดรธานีจึงเป็นจังหวัดที่มีชื่อเสียงด้านการทอผ้าลายขิดฝ้ายและไหม
          จากการประกวดผ้าลายขิดที่ตำหนักภูพานราชนิเวศน์
          ผ้าลายขิดฝ้ายและไหมของจังหวัดอุดรธานีชนะเลิศติดต่อกันมาเป็นประจำทุกปี
          ตั้งแต่เริ่มมีการประกวดจนถึงปัจจุบัน
        </div>
        <br />
        <div className="font_Kanit ">
          จากที่กล่าวมาข้างต้นจะเห็นได้ว่าจังหวัดอุดรธานีและจังหวัดใกล้เคียงรวมไปถึงประเทศเพื่อนบ้านในอนุลุ่มแม่น้ำโขงอย่าง
          สปป.ลาว
          ซึ่งมีชาติพันธุ์ร่วมกันทางประวัติศาสตร์ร่วมกับชาวอีสานในปัจจุบัน
          มีการทอผ้ากันอย่างแพร่หลายเป็นรากทางวัฒนธรรมซึ่งผู้หญิงอีสานมีหน้าที่ติดตัวมาคือการต่ำหูกหรือการทอผ้า
          เด็กหญิงเมื่อเริ่มรู้จักหน้าที่อายุ 6-7
          ขวบจะเรียนรู้การทอผ้าจากแม่และผู้เฒ่าผู้แก่เป็นการสอนตัวต่อตัว
          ปากต่อปาก มือต่อมือ หูกต่อหูก โดยไม่มีเอกสารตำราให้ศึกษาเล่าเรียน
          แต่เป็นการถ่ายทอดไม่เฉพาะแต่การทอผ้าเท่านั้นแต่ยังสอดแทรกนิทาน
          ภาษิตสอนใจ คติความเชื่อต่างๆ
          ที่ปรากฏในลวดลายผ้าทอได้ถูกกล่อมเกลาปลูกฝังมาตั้งแต่ยังเล็กยังน้อยรวมถึงจารีตประเพณีในการแต่งกายนุ่งถือผ้าประเภทต่างๆ
          จะถูกสั่งสมบ่มเพาะและสืบทอดสั่งสอนกันจากรุ่นสู่รุ่นเรื่อยมากลายเป็นมรดกทางวัฒนธรรมของครอบครัวมายาวนาน
        </div>
        <br />
        <div className="font_Kanit ">
          ด้วยพระบรมราโชบายสมเด็จพระเจ้าอยู่หัวมหาวชิราลงกรณบดินทรเทพยวรางกูร
          รัชกาลที่ 10 ต่อมหาวิทยาลัยราชภัฏให้เป็นที่พึ่งของชุมชนท้องถิ่น
          ได้สะท้อนให้ชาวมหาวิทยาลัยราชภัฏทั้งปวงได้ตระหนักถึงพันธกิจต่อชุมชนท้องถิ่นเป็นสำคัญโดยเฉพาะในด้านการพัฒนาท้องถิ่น
          เพื่อยกระดับคุณภาพชีวิต สังคม
          เศรษฐกิจรายได้เพื่อยกระดับคุณภาพชีวิตให้มั่นคงยั่งยืน
          เพื่อให้มหาวิทยาลัยราชภัฏเป็นที่พึงและขุมปัญญาเพื่อนำพาให้ชุมชนท้องถิ่นพัฒนาอย่างมั่นคงยั่งยืน
          มหาวิทยาลัยราชภัฏอุดรธานีมีพื้นที่บริการ 5
          จังหวัดประกอบด้วยจังหวัดอุดรธานี จังหวัดเลย จังหวัดหนองบัวลำภู
          จังหวัดหนองคายและจังหวัดบึงกาฬ
          บทบาทและหน้าที่ของการเป็นสถาบันอุดมศึกษาเพื่อการพัฒนาท้องถิ่น
          มหาวิทยาลัยราชภัฏอุดรธานีจึงให้ความสำคัญกับพันธกิจในการจัดการศึกษา
          การวิจัย
          การบริการวิชาการและการทำนุบำรุงศิลปวัฒนธรรมเพื่อตอบสนองการพัฒนาชุมชนท้องถิ่นมาอย่างต่อเนื่อง
        </div>
        <br />
        <div className="font_Kanit ">
          ดั้งนั้นเพื่อเป็นการสนับสนุนแนวนโยบายตามพระบรมราโชบายและสอดคล้องกับนโยบายการพัฒนากลุ่มจังหวัดอีสานตอนบนในการยกระดับผลิตภัณฑ์ผ้าทอพื้นเมืองให้เป็นอาชีพโดยบูรณาการภูมิปัญญาดั้งเดิมของการทอผ้าพื้นเมืองมาประยุกต์กับองค์ความรู้และเทคโนโลยีเพื่อสร้างมูลค่าผ้าทอพื้นเมืองให้มีศักยภาพในการช่วยสร้างอาชีพและสร้างรายได้ลงไปสู่ชุมชนอย่างยั่งยืน
          การจัดตั้งศูนย์ออกแบบสร้างสรรค์ผ้าและสิ่งทอ :  FTCDC (Fabric and
          Textile Creative Design Center) มหาวิทยาลัยราชภัฏอุดรธานี
          เพื่อการศึกษารวบรวมวัฒนธรรมภูมิปัญญาและองค์ความรู้ผ้าทอพื้นเมืองในจังหวัดอุดรธานีและพื้นที่ภาคตะวันออกเฉียงเหนือตอนบน
          – สปป.ลาว การพัฒนากระบวนการผลิต เส้นใยและสีธรรมชาติ
          ยกระดับและสร้างมูลค่าผลิตภัณฑ์ผ้าทอพื้นเมืองของชุมชนถิ่นอย่างยั่งยืน
          การสร้างพิพิธภัณฑ์ผ้าทอพื้นเมืองอีสานและแหล่งเรียนรู้
          เพื่ออนุรักษ์และการเผยแพร่วัฒนธรรม ภูมิปัญญา
          องค์ความรู้ผ้าทอพื้นเมืองเนื่องจากจังหวัดอุดรธานีและจังหวัดใกล้เคียงยังไม่มีพิพิธภัณฑ์ผ้าทอพื้นเมืองประกอบกับเป็นหมุดหมายที่สำคัญของการเป็นเมือง
          “ธานีผ้าหมี่ขิด”และยังเป็นแหล่งเรียนรู้แหล่งท่องเที่ยวเชิงวัฒนธรรมด้านการทอผ้าพื้นเมืองตั้งแต่ต้นน้ำ
          กลางน้ำและปลายน้ำ แห่งแรกในภาคตะวันออกเฉียงเหนือ
          รวมถึงศึกษาวิจัยนวัตกรรมเส้นใยและสีย้อมจากธรรมชาติ
          การเผยแพร่องค์ความรู้วัฒนธรรมภูมิปัญญาและองค์ความรู้ผ้าทอพื้นเมืองอีกด้วย
        </div>
        <br />
        <br />
        <div
          className="font_Kanit font-semibold  "
          style={{ fontSize: "36px", color: "#B36427" }}
        >
          Mission - วัตถุประสงค์
        </div>
        <br />
        <div className="font_Kanit  ">
          1.
          ศึกษารวบรวมวัฒนธรรมภูมิปัญญาและองค์ความรู้ผ้าทอพื้นเมืองในจังหวัดอุดรธานีและพื้นที่ภาคตะวันออกเฉียงเหนือตอนบน
          – สปป.ลาว <br />
          2. พัฒนากระบวนการผลิต เส้นใยและสีย้อมธรรมชาติ ด้วยนวัตกรรม เทคโนโลยี
          เพื่อยกระดับและสร้างมูลค่าผลิตภัณฑ์ผ้าทอพื้นเมืองของชุมชนถิ่นอย่างยั่งยืน
          <br />
          3. สร้างพิพิธภัณฑ์ผ้าทอพื้นเมืองอีสาน เพื่อเป็นแหล่งเรียนรู้
          การอนุรักษ์และการเผยแพร่วัฒนธรรม ภูมิปัญญา
          องค์ความรู้ผ้าทอพื้นเมืองให้แพร่หลาย
          <br />
          4. ศึกษาวิจัยถ่ายทอดองค์ความรู้ดั้งเดิม
          การประยุกต์นวัตกรรมในการพัฒนาผ้าและสิ่งทอส฿ชุมชน
          เพื่อยกระดับผลิตภัณฑ์และชุมชนทอผ้าพื้นเมืองสู่มาตรฐาน
          <br />
          5. เผยแพร่องค์ความรู้วัฒนธรรมภูมิปัญญาและองค์ความรู้ผ้าทอพื้นเมือง
        </div>
        <br />
        <br />
        <div
          className="font_Kanit font-semibold"
          style={{ fontSize: "36px", color: "#B36427" }}
        >
          ผลผลิต (Output) ที่คาดจะได้รับ
        </div>
        <br />
        <div className="font_Kanit  ">
          1.
          ได้องค์ความรู้ด้านวัฒนธรรมภูมิปัญญาผ้าทอพื้นเมืองในจังหวัดอุดรธานีและพื้นที่ภาคตะวันออกเฉียงเหนือตอนบน
          – สปป.ลาว <br />
          2.
          ชุมชนที่ผลิตผ้าทอพื้นเมืองในท้องถิ่นได้รับการส่งเสริมพัฒนากระบวนการผลิต
          เส้นใยและสีธรรมชาติ
          ยกระดับและสร้างมูลค่าผลิตภัณฑ์ผ้าทอพื้นเมืองของชุมชนถิ่นอย่างยั่งยืน
          <br />
          3.
          มีพิพิธภัณฑ์แหล่งเรียนรู้วัฒนธรรมภูมิปัญญาและองค์ความรู้ผ้าทอพื้นเมืองอีสานเป็นแหล่งศึกษาเรียนรู้สำหรับเยาวชน
          นักวิชาการ หน่วยงานองค์กรภาครัฐและเอกชนทั้งในและต่างประเทศ <br />
          4.
          เสริมสร้างและสนับสนุนการเผยแพร่องค์ความรู้วัฒนธรรมภูมิปัญญาและองค์ความรู้ผ้าทอพื้นเมือง
          การสร้างการรับรู้และการมีส่วนร่วมในการแลกเปลี่ยนเรียนรู้ ระหว่างชุมชน
          ปราชญ์ นักวิชาการ ผู้สนใจด้านผ้าทอทั้งชาวไทยและชาวต่างประเทศ
          <br />
          5.
          มีศูนย์ทดสอบและรับรองมาตรฐานเส้นใยและผลิตภัณฑ์ผ้าทอพื้นเมืองที่มีมาตรฐานสำหรับบริการกลุ่มชุมชน
          ผู้ประกอบการผลิตผ้าทอพื้นเมือง
          <br />
          6. มีระบบสารสนเทศองค์ความรู้และฐานข้อมูลผ้าทอพื้นเมือง
          สนับสนุนทั้งทางด้านวิชาการสำหรับหน่วยงานองค์กรรัฐ เอกชน
          และเป็นส่วนสนับสนุนการสืบค้น และช่องทางจำหน่ายสำหรับกลุ่มทอผ้า
        </div>
        <br />
        <br />
        <div
          className="font_Kanit font-semibold"
          style={{ fontSize: "36px", color: "#B36427" }}
        >
          ผลลัพธ์ (Outcome) ที่คาดจะได้รับ
        </div>
        <br />
        <div className="font_Kanit  ">
          1. ประโยชน์จากงานวิจัยองค์ความรู้ผ้าทอพื้นเมือง จัดทำเป็นหนังสือ
          และบทความตีพิมพ์เผยแพร่
          นำมาสู่การจัดระบบสารสนเทศองค์ความรู้และฐานข้อมูลผ้าทอพื้นเมือง
          เพื่อเป็นช่องทางในการเป็นฐานข้อมูลการศึกษาสำหรับนักวิชาการ ผู้สนใจ{" "}
          <br />
          2. ประโยชน์จากนวัตกรรมการออกแบบ เส้นใยและสีย้อมธรรมชาติ
          นำไปจัดทำเป็นหลักสูตรระยะสั้นเพื่อจัดอบรมเชิงปฏิบัติการเพื่อถ่ายทอดองค์ความรู้ไปยังกลุ่มชุมชน
          ผู้ประกอบการผ้าทอ <br />
          3.
          ประโยชน์จากพิพิธภัณฑ์แหล่งเรียนรู้วัฒนธรรมภูมิปัญญาและองค์ความรู้ผ้าทอพื้นเมืองอีสาน
          เป็นถานที่จัดแสดงเพื่อให้ความรู้ความเข้าใจเรื่องผ้าทอพื้นเมืองในทุกมิติ
          โดยการจัดนิทรรศการแสดงทั้งนิทรรศการระยะยาวและนิทรรศการหมุนเวียน <br />
          4.
          ประโยชน์จากศูนย์ทดสอบและรับรองมาตรฐานเส้นใยและผลิตภัณฑ์ผ้าทอพื้นเมือง
          พัฒนาเป็นศูนย์ทดสอบและให้การรับรองผลิตภัณฑ์ผ้าทอที่ได้มาตรฐาน มผช.
          รวมถึงการใช้คำปรึกษาด้านวัสดุเส้นใย
          การย้อมสีจากธรรมชาติแก่ชุมชนท้องถิ่น <br />
        </div>
        <br />
      </div>

      <div className=" flex-col md:flex-row w-full gap-[40px] items-center">
        <div
          className="flex flex-row items-center gap-4"
          style={{ justifyContent: "center" }}
        >
          <div className="w-5 h-5 bg-[#B36427]" />
          <div
            className="font_Kanit font-semibold cursor-pointer "
            style={{ fontSize: "36px" }}
          >
            Meet Our Teams
          </div>
          <div className="w-5 h-5 bg-[#B36427]" />
        </div>
      </div>
      <br />
      <div className="p-8 flex-col md:flex-row w-full gap-[40px] items-center">
        <div
          className="flex flex-row items-center gap-4"
          style={{ justifyContent: "center" }}
        >
          <div
            className="font_Kanit font-semibold"
            style={{ fontSize: "36px", color: "#B36427" }}
          >
            บุคลากร
          </div>
        </div>
        <br />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 lg:gap-10 px-3 lg:px-12">
          <div className="w-full ">
            <img
              className="object-cover w-full h-full"
              src="/img/frame 46.png"
            />
          </div>
          <div className="w-full ">
            <img
              className="object-cover w-full h-full"
              src="/img/frame 47.png"
            />
          </div>
          <div className="w-full ">
            <img
              className="object-cover w-full h-full"
              src="/img/frame 48.png"
            />
          </div>
          <div className="w-full ">
            <img
              className="object-cover w-full h-full"
              src="/img/frame 49.png"
            />
          </div>
        </div>
        <br />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 lg:gap-10 px-3 lg:px-12">
          <div className="w-full ">
            <img
              className="object-cover w-full h-full"
              src="/img/frame 50.png"
            />
          </div>
          <div className="w-full ">
            <img
              className="object-cover w-full h-full"
              src="/img/frame 51.png"
            />
          </div>
          <div className="w-full ">
            <img
              className="object-cover w-full h-full"
              src="/img/frame 52.png"
            />
          </div>
          <div className="w-full ">
            <img
              className="object-cover w-full h-full"
              src="/img/frame 53.png"
            />
          </div>
        </div>
      </div> */}
      <CustomBottom />
    </div>
  );
}
